import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/task-aperte',
        name: 'task-aperte',
        component: () => import(/* webpackChunkName: "task-aperte" */ '../views/TaskAperte.vue'),
    },
    {
        path: '/notifiche',
        name: 'notifiche',
        component: () => import(/* webpackChunkName: "notifiche" */ '../views/Notifiche.vue'),
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

export default router
